/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PromoCode_user = {|
  +isPromoCodeEligible: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PromoCode_user",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "code",
          "value": "SAVE15",
          "type": "String!"
        }
      ],
      "name": "isPromoCodeEligible",
      "storageKey": "isPromoCodeEligible{\"code\":\"SAVE15\"}"
    }
  ],
  "type": "User"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Sidebar/__generated__/PromoCode_user.graphql.js